import * as Yup from 'yup';

export const performanceFormSchema = Yup.object({
  notes: Yup.string().nullable(),
  kpis: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.number()
          .typeError('Value must be a number')
          .max(10, 'Value must be less than or equal to 10')
          .nullable(),
        value: Yup.string().required('Please Enter KPI Value'),
        kpiId: Yup.string().required('Please Enter KPI ID'),
        notes: Yup.string().optional()
      })
    )
    .nullable(),
  average: Yup.number().typeError('Average must be a number')
});
